import Vue from "vue";

const modulo_presupuestos = {
    strict: false,

    state: {
        presupuestos: [],
        metodos_pago: [],
        current: 0,
        rol: null,
    },

    getters: {
        getpresupuestos: (state) => state.presupuestos,
    },

    mutations: {
        get_presupuestos: (state, presupuestos) => {
            state.presupuestos = presupuestos.data;
            state.page = 2;
        },
        update_presupuestos: (state, presupuestos) => {
            state.presupuestos = state.presupuestos.concat(presupuestos.data);
            state.page = presupuestos.current_page + 1;
        },
    },

    actions: {
        getPresupuestos: (context, vm) => {
            let rol = null;
            if (vm?.rol != null) {
                rol = vm?.rol;
            }
            axios.get(`api/get-presupuestos?page=1&amount=15`).then(
                (res) => {
                    context.commit("get_presupuestos", res.data);
                },
                (res) => {}
            );
        },
        getPresupuestosNext: (context, vm) => {
            let rol = null;
            if (vm?.rol != null) {
                rol = vm?.rol;
            }
            axios
                .get(
                    `api/get-presupuestos?page=${
                        context.state.page ?? 1
                    }&amount=15`
                )
                .then(
                    (res) => {
                        context.commit("update_presupuestos", res.data);
                    },
                    (res) => {}
                );
        },
        searchPresupuesto: (context, vm) => {
            let rol = null;
            if (vm?.rol != null) {
                rol = vm?.rol;
            }
            axios
                .get(
                    `api/get-presupuestos?page=1${
                        vm.search ? `&busqueda=${vm.search}` : ""
                    }&amount=15`
                )
                .then(
                    (res) => {
                        context.commit("update_presupuestos", res.data);
                    },
                    (res) => {}
                );
        },
    },
};

export default modulo_presupuestos;
